import { render } from "./PointsDice.vue?vue&type=template&id=0236c33a&scoped=true"
import script from "./PointsDice.vue?vue&type=script&lang=js"
export * from "./PointsDice.vue?vue&type=script&lang=js"

import "./PointsDice.vue?vue&type=style&index=0&id=0236c33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0236c33a"]])

export default __exports__